import React from 'react';
import {Outlet} from "react-router-dom";
import {AuthService} from "../../service/AuthService";
import {Forbidden} from "../../components/Forbidden";

export const Season = () => {
  return (
    <>
      { !AuthService.hasRole('ROLE_CALENDRIER') && (
        <Forbidden module="season"/>
      )}
      { AuthService.hasRole('ROLE_CALENDRIER') && (
        <Outlet/>
      )}
    </>
  );
}
